/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 * var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 * var variant = event.detail.variant; // Get the variant that was added
 * var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 * bubbles: true
 * }));
 */


/* Collapsibles */
var	collapsibles		= document.querySelectorAll('.ProductMeta__Description h4');
var	collapse			= function(current, onload) {
	var	collapsibles	= document.querySelectorAll('.ProductMeta__Description h4');
	[].forEach.call(collapsibles, function(collapsible) {
		if (collapsible == current || (onload === true && collapsible.classList.contains('onload'))) {
			if (current.nextElementSibling) {
				var content = current.nextElementSibling;
				if (content.style.maxHeight) {
					current.classList.remove('active');
					content.style.maxHeight = null;
				} else {
					current.classList.add('active');
					content.style.maxHeight = content.scrollHeight + 'px';
				}
			}
		} else {
			collapsible.classList.remove('active');
			var content = collapsible.nextElementSibling;
			if (content) content.style.maxHeight = null;
		}
	});
};
[].forEach.call(collapsibles, function(collapsible) {
	collapsible.addEventListener('mousedown', function(event) {
		event.preventDefault();
		collapse(this);
	});
});
var onload = document.querySelector('.ProductMeta__Description h4.onload');
if (onload) collapse(onload);

// Ignore blank links
var links = document.querySelectorAll('a[href="#"]');
if (links) {
 links.forEach(function(link) {
  link.addEventListener('click', function(event) {
   event.preventDefault();
   return false;
  });
 });
}

// Klaviyo forms
var forms = document.querySelectorAll('.klaviyo');

if (forms.length) {
	
	function initForms() {
		[].forEach.call(forms, function (form) {
			bindForm(form);
		});
	}
	
	function bindForm(form) {
		var source = form.querySelector('[name="source"]');
		KlaviyoSubscribe.attachToForms(form, {
			hide_form_on_success: true,
			success_message: window.languages['newsletterThankYou'],
			extra_properties: {
				$source: source ? source.value : 'unknown'
			},
			success: function ($form) {
				var thanks = form.parentNode.querySelector('.thanks');
				if (thanks) {
					form.style.display		= 'none';
					thanks.style.display	= 'block';
				} else {
					alert(window.languages['newsletterThankYou']);
				}
			 }
		});
	}
	
	window.addEventListener('load', function(){
		var scriptTag = document.createElement('script');
		scriptTag.src = 'https://www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
		scriptTag.onload = initForms;
		scriptTag.onreadystatechange = initForms;
		document.body.appendChild(scriptTag);
	});
}

// Announcement bar auto-rotation fix
// The AnnouncementBar and Slideshow__Carousel are on the same element
window.addEventListener('load', function() {
  var el = document.querySelector('.AnnouncementBar.Slideshow__Carousel');
  if (!el || typeof Flickity === 'undefined') return;
  var flkty = Flickity.data(el);
  if (!flkty) return;
  flkty.stopPlayer();
  setInterval(function() { flkty.next(); }, 4000);
});